export function formatPrice(value) {
  const parsed = Number(value)
  if (!Number.isFinite(parsed)) return '0'

  return parsed.toLocaleString('ru-RU', {
    minimumFractionDigits: Number.isInteger(parsed) ? 0 : 2,
    maximumFractionDigits: 2,
  })
}
